/* Oli & Home · Light up the season: holiday scent quiz (sections/oli-holiday-quiz.liquid).
   Each answer adds points to candles; the highest total wins, ties go to the order in RESULTS
   (the two new winter scents and Toasted Croissant first). Product prices and stock come from the section. */
(function () {
  const CDN = 'https://cdn.shopify.com/s/files/1/0910/8602/9184/files/';

  const RESULTS = {
    wg: { name: 'Winter Garland', handle: 'fresh-pine-dried-orange-winter-spices-scented-candle', image: 'Winter_Garland-1.webp',
      notes: ['Fresh pine', 'Dried orange', 'Winter spice', 'Woods'], persona: 'The Garland Hanger',
      blurb: 'The decorations went up before the clocks went back, and you would do it again tomorrow. Winter Garland is pine, dried orange and winter spice: the mantelpiece you have been styling since November, in a jar.',
      forecast: 'Heavy tinsel showers, with a 100% chance of carols.', pair: { handle: 'winter-garland-wax-melts', name: 'Winter Garland Wax Melts', line: 'For the kitchen, the hallway and every room the tree can’t reach.' }, isNew: true },
    ml: { name: 'Mountain Lodge', handle: 'cedar-woodsmoke-scented-candle', image: 'MountainLodge-1.webp',
      notes: ['Cedar', 'Woodsmoke', 'Citrus', 'Frozen air'], persona: 'The Cabin Dreamer',
      blurb: 'Your ideal party has a guest list of one, a log burner and a very long walk beforehand. Mountain Lodge is warm cedar and soft woodsmoke with a bright snap of frozen air: coming in from the frost, boots by the door.',
      forecast: 'Crisp and clear, with the fire roaring by four.', pair: { handle: 'mountain-lodge-wax-melts', name: 'Mountain Lodge Wax Melts', line: 'The cabin feeling, one snap-off square at a time.' }, isNew: true },
    cr: { name: 'Toasted Croissant', handle: 'croissant-buttery-pastry-scented-candle', image: 'Toasted_Croissant-2.webp',
      notes: ['Melted butter', 'Warm pastry', 'Cream', 'Vanilla'], persona: 'The Breakfast Legend',
      blurb: 'Everyone knows the best part of the holidays happens before 10am, and it involves pastry. Toasted Croissant is melted butter, warm pastry and a little vanilla: the smell of a morning with nowhere to be.',
      forecast: 'Scattered crumbs, clearing to a second croissant.', pair: { handle: 'coffee-and-croissant-candle-set-duo', name: 'The Corner Café Duo', line: 'Croissant and Caffè Latte together, in one kraft gift box.' } },
    la: { name: 'Caffè Latte', handle: 'caffe-latte-scented-candle-fresh-coffee-hazelnut-cream', image: 'Cafe_Latte-2.webp',
      notes: ['Roasted coffee', 'Cocoa', 'Hazelnut', 'Vanilla'], persona: 'The Midnight Wrapper',
      blurb: 'Presents? Wrapped. At 11.58pm on Christmas Eve, sellotape in your teeth and a coffee in hand. Caffè Latte is roasted coffee, cocoa and hazelnut for every heroic last-minute effort.',
      forecast: 'Sellotape storms, with a strong brew all night.', pair: { handle: 'coffee-and-croissant-candle-set-duo', name: 'The Corner Café Duo', line: 'Coffee and croissant, for the morning after the wrapping.' } },
    ev: { name: 'Fresh Evergreens', handle: 'fresh-evergreens-balsam-fir-cedarwood-scented-candle', image: 'Fresh_Evergreens-2.webp',
      notes: ['Balsam fir', 'Cedarwood', 'Oakmoss', 'Pine'], persona: 'The Real-Tree Purist',
      blurb: 'You choose the tree by smell and you will still be finding needles in March. Fresh Evergreens is balsam fir, cedarwood and pine: all of the forest, none of the hoovering.',
      forecast: 'Woodland breezes, with needles underfoot.', pair: { handle: 'the-nature-escape-duo-fresh-evergreens-rainforest-mist-candle-set', name: 'The Nature Escape Duo', line: 'Fresh Evergreens with Rainforest Mist, boxed and ribboned.' } },
    qh: { name: 'Quiet Hours', handle: 'berries-rose-musk-scented-candle', image: 'Quiet_Hours-1.webp',
      notes: ['Cassis', 'Raspberry', 'Rose', 'Musk'], persona: 'The Afterglow Host',
      blurb: 'You are still chatting long after the plates are cleared and the music is turned down. Quiet Hours is cassis, raspberry and rose for the soft hour after everyone has gone home.',
      forecast: 'Calm evenings, with gentle spells of gossip.', pair: { handle: 'the-slow-evening-candle-set-duo', name: 'The Slow Evening Duo', line: 'Quiet Hours with Serenity, for the last hours of the day.' } },
    se: { name: 'Serenity', handle: 'serenity-scented-candle-lavender-chamomile-vanilla', image: 'Serenity-1.webp',
      notes: ['Lavender', 'Chamomile', 'Vanilla', 'Cedarwood'], persona: 'The Sofa Champion',
      blurb: 'Paper hat on, film paused, absolutely not moving. Serenity is lavender, chamomile and vanilla for the most important appointment of the season: doing nothing at all.',
      forecast: 'Settled, with long spells of blanket.', pair: { handle: 'the-slow-evening-candle-set-duo', name: 'The Slow Evening Duo', line: 'Serenity with Quiet Hours, two slow evenings in one box.' } },
    sz: { name: 'Sunday Zest', handle: 'bergamot-ginger-citrus-scented-candle', image: 'Sunday_Zest-3.webp',
      notes: ['Bergamot', 'Orange blossom', 'Neroli', 'Ginger'], persona: 'The Countdown Starter',
      blurb: 'You have the playlist, the sparklers and a toast already written. Sunday Zest is bergamot, orange blossom and ginger, as bright as the first morning of a brand-new year.',
      forecast: 'Sparkling, with a high chance of dancing.', pair: { handle: 'citrus-eucalyptus-candle-set-duo', name: 'The Sundaze Duo', line: 'Sunday Zest with Eucalyptus Haze, clear first and then golden.' } },
    wo: { name: 'Warm Orchard', handle: 'peach-fruity-scented-candle', image: 'Warm_Orchard-1.webp',
      notes: ['Peach blossom', 'Honey', 'Vanilla', 'Sandalwood'], persona: 'The Glow Bringer',
      blurb: 'Lamps on every step, sweets on every plate and the door always open. Warm Orchard is peach blossom, honey and soft sandalwood for golden evenings full of guests.',
      forecast: 'Golden and glowing, with sweets all round.', pair: { handle: 'warm-orchard-wax-melts', name: 'Warm Orchard Wax Melts', line: 'The same golden warmth for the burner by the door.' } },
    rm: { name: 'Rainforest Mist', handle: 'petrichor-rain-moss-scented-candle', image: 'Rainforest_Mist-1.webp',
      notes: ['Petrichor', 'Damp earth', 'Foliage', 'Forest air'], persona: 'The Rainy-Day Romantic',
      blurb: 'Grey sky outside, kettle on inside, and you are absolutely delighted about it. Rainforest Mist is petrichor, damp earth and cool forest air: a walk in the rain without leaving the sofa.',
      forecast: 'Drizzle all day, cosy and quietly perfect.', pair: { handle: 'the-nature-escape-duo-fresh-evergreens-rainforest-mist-candle-set', name: 'The Nature Escape Duo', line: 'Rainforest Mist with Fresh Evergreens, for anyone happiest outdoors.' } },
  };
  const ORDER = Object.keys(RESULTS);

  const QUESTIONS = [
    { q: 'It’s the first properly cold evening of the season. Which window is yours?', pictures: true, answers: [
      { img: 'window', t: 'Tree up, lights on', s: 'It’s November and I regret nothing.', p: { wg: 3, ev: 1 } },
      { img: 'cabin', t: 'Log burner roaring', s: 'Phone somewhere I can’t hear it.', p: { ml: 3, rm: 1 } },
      { img: 'diyas', t: 'Diyas on every step', s: 'Sweets on every plate, door wide open.', p: { wo: 3, qh: 1 } },
      { img: 'sparklers', t: 'Sparklers at the ready', s: 'Already planning the New Year’s Eve outfit.', p: { sz: 3, la: 1 } },
    ] },
    { q: 'Pick your festive breakfast.', answers: [
      { e: '🥐', t: 'A warm croissant', s: 'Crumbs on the jumper, zero regrets.', p: { cr: 3 } },
      { e: '☕', t: 'Coffee. Then more coffee.', s: 'It’s a marathon, not a sprint.', p: { la: 3 } },
      { e: '🍊', t: 'The clementine from the stocking', s: 'Peeled in one perfect spiral.', p: { wg: 2, sz: 1 } },
      { e: '🍬', t: 'Whatever’s left in the sweet tin', s: 'Breakfast is a state of mind.', p: { wo: 2, qh: 2 } },
    ] },
    { q: 'Your role at the big get-together?', answers: [
      { e: '🧑‍🍳', t: 'The host', s: 'Up since six. Everything is fine. EVERYTHING IS FINE.', p: { cr: 2, la: 1, wo: 1 } },
      { e: '🎲', t: 'Board-game champion', s: 'Slightly too competitive. Knows it.', p: { ml: 1, ev: 1, la: 1 } },
      { e: '🎶', t: 'DJ and toast-maker', s: 'First on the dance floor, last to leave it.', p: { sz: 2, qh: 1 } },
      { e: '🛋️', t: 'Asleep by four', s: 'Paper hat still on.', p: { se: 3, qh: 1 } },
    ] },
    { q: 'Choose this season’s soundtrack.', answers: [
      { e: '🔥', t: 'The crackle of a real fire', s: 'Best album ever made.', p: { ml: 3 } },
      { e: '🔔', t: 'Sleigh bells and a choir', s: 'Humming along by the second verse.', p: { wg: 2, ev: 1 } },
      { e: '🎆', t: 'Fireworks lighting up the sky', s: 'Bonfire Night, Diwali, midnight: all of it.', p: { sz: 2, wo: 2 } },
      { e: '🌧️', t: 'Rain on the window', s: 'And absolutely no plans.', p: { rm: 3, se: 1 } },
    ] },
    { q: 'The great debate: real tree or fake?', answers: [
      { e: '🌲', t: 'Real, obviously', s: 'I want needles in the carpet until March.', p: { ev: 3, wg: 1 } },
      { e: '✨', t: 'Fake, fluffed to perfection', s: 'I’d rather fluff than hoover.', p: { la: 1, sz: 1, cr: 1 } },
      { e: '🌿', t: 'A single branch in a jar', s: 'It’s a whole look, actually.', p: { rm: 2, ev: 1 } },
      { e: '🪔', t: 'Tree? I’m here for the lights', s: 'And the snacks. Mostly the snacks.', p: { wo: 2, cr: 1, qh: 1 } },
    ] },
    { q: 'The gift you’re secretly hoping for…', answers: [
      { e: '📚', t: 'A big book', s: 'And permission to ignore everyone.', p: { se: 2, qh: 2 } },
      { e: '🧣', t: 'A scarf that smells of woodsmoke', s: 'From someone who knows me.', p: { ml: 2, ev: 1 } },
      { e: '🥂', t: 'Tickets to something sparkly', s: 'Dress code: glitter.', p: { qh: 2, sz: 1 } },
      { e: '🍪', t: 'Something homemade', s: 'Ideally edible. Definitely edible.', p: { cr: 2, wo: 1 } },
    ] },
    { q: 'When it’s all over, how do you want to feel?', answers: [
      { e: '😴', t: 'Rested', s: 'Deeply, gloriously rested.', p: { se: 2, rm: 1, qh: 1 } },
      { e: '🍽️', t: 'Full', s: 'Of food, mostly.', p: { cr: 2, la: 1 } },
      { e: '🥾', t: 'Like I’ve been on a winter walk', s: 'Rosy cheeks, cold nose, happy.', p: { ev: 2, ml: 1, rm: 1 } },
      { e: '🎉', t: 'Ready for a brand-new year', s: 'Big plans. Bigger playlist.', p: { wg: 2, sz: 1 } },
    ] },
  ];

  const root = document.querySelector('[data-ohq]');
  if (!root) return;
  const shop = JSON.parse(document.querySelector('[data-ohq-shop]').textContent);
  const stage = root.querySelector('[data-ohq-stage]');
  const live = root.querySelector('[data-ohq-live]');
  const bulbs = [...root.querySelectorAll('.ohq__bulb')];
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let step = 0;
  let picks = [];

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const img = (file, w) => `${CDN}${file}?width=${w}`;
  const wait = (ms) => new Promise((r) => setTimeout(r, calm ? 0 : ms));

  function light(count) {
    bulbs.forEach((b, i) => b.classList.toggle('is-lit', i < count));
  }

  function swap(html, cls) {
    stage.classList.remove('is-in');
    stage.innerHTML = html;
    stage.className = 'ohq__stage ' + (cls || '');
    requestAnimationFrame(() => stage.classList.add('is-in'));
    const heading = stage.querySelector('h2, h1');
    if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    keepInView();
  }

  // Bring the top of the quiz back under the (sticky) site header when a new step starts.
  function keepInView() {
    const header = document.querySelector('header-component');
    const offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const top = root.getBoundingClientRect().top;
    if (top < offset - 1 || top > window.innerHeight * 0.35) {
      window.scrollTo({ top: window.scrollY + top - offset, behavior: calm ? 'auto' : 'smooth' });
    }
  }

  function ask() {
    const item = QUESTIONS[step];
    const cards = item.answers.map((a, i) => `
      <button type="button" class="ohq__answer${item.pictures ? ' ohq__answer--pic' : ''}" data-i="${i}" style="--d:${i * 70}ms">
        ${item.pictures ? `<span class="ohq__pic"><img src="${shop.assets[a.img]}" alt="" width="900" height="1125" loading="eager"></span>` : `<span class="ohq__emoji" aria-hidden="true">${a.e}</span>`}
        <span class="ohq__answer-text"><strong>${esc(a.t)}</strong><span>${esc(a.s)}</span></span>
      </button>`).join('');
    swap(`
      <div class="ohq__card">
        <p class="ohq__count">Question ${step + 1} <span>of ${QUESTIONS.length}</span></p>
        <h2 class="ohq__q">${esc(item.q)}</h2>
        <div class="ohq__answers${item.pictures ? ' ohq__answers--pics' : ''}">${cards}</div>
        ${step ? '<button type="button" class="ohq__back" data-ohq-back>← Back</button>' : ''}
      </div>`, 'is-question');
    live.textContent = `Question ${step + 1} of ${QUESTIONS.length}. ${item.q}`;
  }

  function tally() {
    const score = Object.fromEntries(ORDER.map((k) => [k, 0]));
    picks.forEach((ai, qi) => Object.entries(QUESTIONS[qi].answers[ai].p).forEach(([k, v]) => { score[k] += v; }));
    return ORDER.slice().sort((a, b) => score[b] - score[a] || ORDER.indexOf(a) - ORDER.indexOf(b));
  }

  function buy(handle, label) {
    const p = shop.products[handle] || {};
    if (!p.live || !p.price) return `<a class="ohq__btn ohq__btn--brass" href="${esc(shop.guide)}">Launching soon · see the gift guide</a>`;  // not yet on sale (Draft)
    if (!p.available) return `<a class="ohq__btn ohq__btn--ghost" href="${esc(p.url)}">Sold out for now · ${p.price}</a>`;
    return `<form method="post" action="${esc(shop.cartAdd)}" class="ohq__buy"><input type="hidden" name="id" value="${p.variant}"><input type="hidden" name="quantity" value="1">
      <button type="submit" class="ohq__btn ohq__btn--brass">${esc(label)} · ${p.price}</button></form>`;
  }

  function link(handle) {
    const p = shop.products[handle] || {};
    return p.live && p.price ? p.url : shop.guide;
  }

  async function wrap() {
    light(bulbs.length);
    swap(`
      <div class="ohq__wrap">
        <p class="ohq__count">All seven answered. The lights are on.</p>
        <h2 class="ohq__q">Your candle is wrapped and waiting</h2>
        <button type="button" class="ohq__gift" data-ohq-unwrap aria-label="Unwrap your result">
          <span class="ohq__gift-lid"></span><span class="ohq__gift-box"></span><span class="ohq__gift-tag">for you</span>
        </button>
        <p class="ohq__small">Tap the present to unwrap it.</p>
      </div>`, 'is-wrap');
    live.textContent = 'Your result is ready. Activate the present to unwrap it.';
  }

  async function reveal(btn) {
    btn.classList.add('is-open');
    await wait(900);
    const [first, second] = tally();
    const r = RESULTS[first];
    const plus = RESULTS[second];
    const pairLive = shop.products[r.pair.handle] || {};
    swap(`
      <div class="ohq__result">
        <div class="ohq__result-media">
          <a href="${esc(link(r.handle))}" class="ohq__result-photo"><img src="${img(r.image, 900)}" alt="${esc(r.name)} candle" width="900" height="1125"></a>
          <span class="ohq__result-label"><span class="ohq__script">${esc(r.name)}</span></span>
          ${r.isNew ? '<span class="ohq__new">New this winter</span>' : ''}
        </div>
        <div class="ohq__result-copy">
          <p class="ohq__eyebrow">Your holiday scent personality</p>
          <h2 class="ohq__persona"><span class="ohq__script">${esc(r.persona)}</span></h2>
          <p class="ohq__match">Your candle: <strong>${esc(r.name)}</strong></p>
          <ul class="ohq__notes">${r.notes.map((n) => `<li>${esc(n)}</li>`).join('')}</ul>
          <p class="ohq__blurb">${esc(r.blurb)}</p>
          <div class="ohq__forecast"><span class="ohq__forecast-icon" aria-hidden="true">❄</span><p><strong>Your holiday forecast</strong>${esc(r.forecast)}</p></div>
          <div class="ohq__actions">${buy(r.handle, 'Add to bag')}<a class="ohq__link" href="${esc(link(r.handle))}">See the candle →</a></div>
          <div class="ohq__extras">
            <a class="ohq__mini" href="${esc(link(plus.handle))}">
              <img src="${img(plus.image, 240)}" alt="" width="120" height="150" loading="lazy">
              <span><em>Your plus-one</em><strong>${esc(plus.name)}</strong><span>${esc(plus.persona)} is a close second.</span></span>
            </a>
            <a class="ohq__mini" href="${esc(link(r.pair.handle))}">
              <span class="ohq__mini-icon" aria-hidden="true">✦</span>
              <span><em>Make it a pair</em><strong>${esc(r.pair.name)}</strong><span>${esc(r.pair.line)}${pairLive.live && pairLive.price ? ' ' + pairLive.price + '.' : ''}</span></span>
            </a>
          </div>
          <div class="ohq__again"><button type="button" class="ohq__link" data-ohq-restart>Take it again ↻</button><a class="ohq__link" href="${esc(shop.guide)}">Shop the Christmas gift guide →</a></div>
        </div>
      </div>`, 'is-result');
    live.textContent = `You are ${r.persona}. Your candle is ${r.name}. Your plus-one is ${plus.name}.`;
  }

  async function plugIn() {
    for (let i = 1; i <= 3; i++) { light(i); await wait(140); }
    light(0);
    await wait(120);
    step = 0; picks = [];
    ask();
  }

  root.addEventListener('click', async (e) => {
    const t = e.target.closest('button');
    if (!t || !root.contains(t)) return;
    if (t.matches('[data-ohq-start]')) return plugIn();
    if (t.matches('[data-ohq-restart]')) { step = 0; picks = []; light(0); return ask(); }
    if (t.matches('[data-ohq-back]')) { step -= 1; picks.pop(); light(step); return ask(); }
    if (t.matches('[data-ohq-unwrap]')) return reveal(t);
    if (t.matches('.ohq__answer')) {
      if (stage.dataset.busy) return;
      stage.dataset.busy = '1';
      t.classList.add('is-picked');
      picks[step] = Number(t.dataset.i);
      light(step + 1);
      await wait(520);
      delete stage.dataset.busy;
      step += 1;
      if (step < QUESTIONS.length) ask(); else wrap();
    }
  });
})();
